module.exports = __webpack_public_path__ + "static/media/ShaderTwo.48a55a8f.frag";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/Shaders/ShaderTwo.frag
// module id = 90
// module chunks = 0